import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";

import { api } from "./api";
import { Btn, Lbl } from "./ui";

const compacto = (n) => {
  if (!n) return "?";
  if (n >= 1e6) return `${(n / 1e6).toFixed(1)}M`;
  if (n >= 1e3) return `${Math.round(n / 1e3)}k`;
  return String(n);
};

/**
 * Segmentación por intereses de un conjunto.
 *
 * No hay catálogo de intereses que se pueda listar —son millones y sólo se llega por búsqueda—
 * así que esto va contra la búsqueda de Meta en vivo. Por lo mismo el generador no los recibe y
 * no puede inventarlos: se eligen acá.
 *
 * Se muestra el tamaño de audiencia porque es lo que decide si un interés sirve: "Guitarra
 * (instrumentos)" son 150M de personas, que con $20 por día es tirar el presupuesto al aire.
 */
export default function SelectorIntereses({ valor, onCambio, disabled }) {
  const [q, setQ] = useState("");
  const [resultados, setResultados] = useState(null);
  const [buscando, setBuscando] = useState(false);
  const [error, setError] = useState(null);

  const elegidos = valor || [];

  function buscar() {
    if (!q.trim()) return;
    setBuscando(true);
    setError(null);
    api
      .intereses(q.trim())
      .then((r) => setResultados(r.intereses || []))
      .catch((e) => setError(e.message))
      .finally(() => setBuscando(false));
  }

  const agregar = (i) => {
    if (elegidos.some((x) => x.id === i.id)) return;
    onCambio([...elegidos, { id: i.id, nombre: i.nombre }]);
  };

  const quitar = (id) => onCambio(elegidos.filter((x) => x.id !== id));

  return (
    <div style={{ borderTop: "1px solid #EEF1F6", marginTop: 8, paddingTop: 8 }}>
      <Lbl>intereses (segmentación detallada)</Lbl>

      {!disabled && elegidos.length === 0 && (
        <div style={{ fontSize: 11.5, color: "#A0AABA", marginBottom: 5 }}>
          El generador nunca los completa —no los tiene en su catálogo—: se buscan y se agregan acá.
          Sin ninguno, el conjunto llega a todo el país.
        </div>
      )}

      {elegidos.length > 0 && (
        <div style={{ display: "flex", gap: 5, flexWrap: "wrap", marginBottom: 6 }}>
          {elegidos.map((i) => (
            <span
              key={i.id}
              style={{
                background: "#EEF4FF", border: "1px solid #C7D9F5", borderRadius: 12,
                padding: "2px 6px 2px 9px", fontSize: 11.5, display: "inline-flex",
                alignItems: "center", gap: 5, color: "#1B3A5C",
              }}
            >
              {i.nombre}
              {!disabled && (
                <button
                  onClick={() => quitar(i.id)}
                  style={{ border: "none", background: "none", cursor: "pointer", color: "#5A7CA8", fontSize: 13, lineHeight: 1, padding: 0 }}
                  title="quitar"
                >
                  ×
                </button>
              )}
            </span>
          ))}
        </div>
      )}

      {/*
        Sin esto, un borrador ya propuesto (que es de sólo lectura) mostraba la etiqueta sola y
        parecía que el panel no tuviera segmentación por intereses. Decirlo explícito.
      */}
      {disabled && elegidos.length === 0 && (
        <div style={{ fontSize: 11.5, color: "#A0AABA" }}>Sin intereses: el conjunto llega a todo el país.</div>
      )}

      {!disabled && (
        <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
          <TextField
            placeholder="buscar interés: guitarra, música, rock…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && buscar()}
            style={{ flex: 1, maxWidth: 320 }}
          />
          <Btn onClick={buscar} disabled={buscando || !q.trim()}>
            {buscando ? "buscando…" : "buscar"}
          </Btn>
          {resultados && (
            <Btn onClick={() => { setResultados(null); setQ(""); }}>cerrar</Btn>
          )}
        </div>
      )}

      {error && <div style={{ color: "#B42318", fontSize: 11.5, marginTop: 4 }}>{error}</div>}

      {resultados && (
        <div style={{ marginTop: 6, border: "1px solid #E3E8F0", borderRadius: 6, maxHeight: 180, overflowY: "auto" }}>
          {resultados.map((i) => {
            const ya = elegidos.some((x) => x.id === i.id);
            return (
              <div
                key={i.id}
                style={{
                  display: "flex", alignItems: "center", gap: 8, padding: "4px 8px",
                  borderBottom: "1px solid #F4F7FB", fontSize: 12,
                }}
              >
                <span style={{ flex: 1 }}>
                  {i.nombre}
                  {i.ruta && <span style={{ color: "#A0AABA" }}> · {i.ruta}</span>}
                </span>
                <span style={{ color: "#7A8699", fontSize: 11 }}>
                  {compacto(i.audiencia_min)}–{compacto(i.audiencia_max)}
                </span>
                <Btn onClick={() => agregar(i)} disabled={ya}>{ya ? "puesto" : "agregar"}</Btn>
              </div>
            );
          })}
          {resultados.length === 0 && (
            <div style={{ padding: 8, color: "#A0AABA", fontSize: 12 }}>Sin resultados.</div>
          )}
        </div>
      )}
    </div>
  );
}
